export default __webpack_public_path__ + "static/media/one_month@3x.ea40bb92.png";